import React from 'react';
import { InView } from 'react-intersection-observer';

import IconDeepResearchSmallI from '@components/Images/DeepResearch/IconDeepResearchSmallI';
import IconDeepResearchText from '@components/Images/DeepResearch/IconDeepResearchText';
import CustomSpinner, { CustomSpinnerColor } from '@components/Spinner/CustomSpinner';
import SuggestedAiPromptCard from '@components/SuggestedAiPromptCard';
import { SuggestedAiPromptCardAs } from '@components/SuggestedAiPromptCard/constants';
import { useAppContext } from '@contexts/AppContext';
import { useCurrentUser } from '@hooks/index';
import useEventTracking from '@hooks/useEventTracking';
import { useSuggestedAiPrompts } from '@hooks/useSuggestedAiPrompts';
import { deep_research_path } from '@routes';
import { ClickTarget, ImpressionElement, TrackingLocation, click, impression } from '@tracking';

const DeepResearch = () => {
  const { currentUser } = useCurrentUser();
  const { isWebview } = useAppContext();
  const { Track, trackEvent } = useEventTracking({
    location: TrackingLocation.DeepResearchMidArticlePromo,
  });
  const { isLoadingSuggestedAiPrompts, suggestedAiPrompts } = useSuggestedAiPrompts();

  const handleLogoClick = () => {
    trackEvent(click({ clickTarget: ClickTarget.DeepResearchLogo }));
  };

  if (isWebview) return null;

  return (
    <Track>
      <aside
        data-testid="mid-article-deep-research-unit"
        className="my-32 bg-[rgba(240,236,229,0.5)] p-16 sm:my-48 md:-ml-[60px] lg:-ml-[84px] dark:bg-[var(--light-grayscale-charcoal)]"
      >
        <InView
          onChange={(inView) => {
            inView &&
              trackEvent(impression({ impressionElement: ImpressionElement.DeepResearchUnit }));
          }}
          triggerOnce
        >
          <div className="flex items-center justify-between">
            <h3 className="m-0 font-suisse-neue text-body-md text-grayscale-charcoal sm:text-subheadline-md">
              {currentUser?.is_pro_subscriber ? 'Try asking' : 'Upgrade to ask'} Deep Research to…
            </h3>
            <a href={deep_research_path()} onClickCapture={handleLogoClick}>
              <IconDeepResearchSmallI className="block w-28 sm:hidden" />
              <IconDeepResearchText className="hidden w-[188px] sm:block" />
            </a>
          </div>
          <div className="mt-28 grid grid-cols-1 gap-20 sm:grid-cols-2 lg:grid-cols-4">
            {isLoadingSuggestedAiPrompts ? (
              <div className="mx-auto mt-8 pt-16">
                <CustomSpinner size={10} color={CustomSpinnerColor.PrimaryMagenta} />
              </div>
            ) : (
              suggestedAiPrompts.map((suggestedPrompt) => (
                <SuggestedAiPromptCard
                  key={suggestedPrompt.icon}
                  as={SuggestedAiPromptCardAs.Anchor}
                  className="w-full !flex-row !p-12 shadow-bottom sm:!flex-col sm:!p-[22px] sm:shadow-right"
                  disablePrompts={false}
                  suggestedAiPrompt={suggestedPrompt}
                />
              ))
            )}
          </div>
        </InView>
      </aside>
    </Track>
  );
};

export default DeepResearch;
